<template>
  <DropdownItem
    v-if="authUser.permission.canLogTime && !this.currentEstate"
    icon="time-clock-circle"
    icon-classes="xy-l-3"
    :label="$t('Track time')"
    :click-fn="addTimeEntry"
  />
</template>

<script>
import ModalService from '/@/modules/core/ui/services/ModalService';
import DropdownItem from '/@/modules/core/app/components/DropdownItem.vue';
import GenericTimeEntryModal from '/@/modules/timeentry/components/presentational/GenericTimeEntryModal.vue';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { HasCurrentEstateMixin } from '@/modules/core/app/mixins/HasCurrentEstateMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TimeEntryDropdownItem',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin],
  components: { DropdownItem },
  methods: {
    addTimeEntry() {
      ModalService.show({
        parent: this,
        component: GenericTimeEntryModal,
        fullScreen: true
      });
    }
  }
};
</script>
